import React from 'react';
import { memo } from 'react';
import _ from 'lodash';

import VHSReferencesDropdown from 'app/components/VHSReferencesDropdown';
import { Patient } from 'app/interfaces/Patient';
import { ImageAnnotations } from 'app/interfaces/Image';
import { AllPredictions } from 'app/interfaces/Predictions';
import { getVHSValue } from 'app/CornerstoneTools/VHSTool';

type VHSInlineDisplayProps = {
  patient: Patient;
  images?: {
    annotations: ImageAnnotations;
    predictions: AllPredictions;
  }[];
};

const VHSInlineDisplay = memo(({ patient, images }: VHSInlineDisplayProps) => {
  const vhsImages = _.filter(images, (image) => !_.isEmpty(image?.annotations?.VHS || {}));

  const imageMaxVHS = _.maxBy(vhsImages, (image) =>
    getVHSValue(Object.values(image.annotations.VHS)[0], 1)
  );
  if (!imageMaxVHS) return null;

  const { predictions, annotations } = imageMaxVHS;

  return (
    <VHSReferencesDropdown
      hideDropdown
      onRaceSelected={() => {}}
      predictions={predictions}
      patientInfo={patient}
      annotations={annotations}
      valueSize="small"
    />
  );
});

export default VHSInlineDisplay;
